/**
 * End-of-report legal disclaimer — shared by in-app render, print/PDF
 * (via SiteRagReportView DOM), and DOCX export.
 *
 * Always-on: not Template Studio–controllable. Mirrors the blindSpots
 * appendix pattern (legal protection must not be toggled off).
 */

export const REPORT_LEGAL_DISCLAIMER_HEADING = 'Important Notice';

/**
 * Short cover/footer notice used on all report variants.
 * Includes confidentiality, beta warning, and a one-sentence
 * summary of the full Important Notice section below.
 *
 * v1.3.4 PRINT-DENSITY (#23): terse rewrite so the DEFAULT cover (the one
 * without an archetype-specific override — see resolveReportPresentation)
 * clamps to exactly one A4 sheet. Keeps the load-bearing substance — BETA
 * workflow + the independent-validation requirement — without the verbose
 * preamble that pushed the cover tall. The FULL legal Important Notice is
 * unchanged below (REPORT_LEGAL_DISCLAIMER_PARAGRAPHS, the end-of-report
 * appendix), so no legal substance is lost from the report.
 */
export const REPORT_COVER_DISCLAIMER = 'Confidential. Beta workflow: directional guidance only; may contain errors. Independently validate all findings with qualified advisors before any decision.';

export const REPORT_LEGAL_DISCLAIMER_PARAGRAPHS: readonly string[] = [
  'This report was produced by the Datacrate platform from your Site Evidence Document (SED), '
  + 'third-party data providers, uploaded site materials, the Coverage Matrix, and the Datacrate '
  + 'analytical model. These inputs are compiled and synthesized at generation time. They represent '
  + 'available evidence at the time of generation, not a complete independent site investigation.',

  'You are responsible for ensuring that all datapoints reflected in your Coverage Matrix, uploaded '
  + 'documents, and project inputs are accurate, complete, and current. The Coverage Matrix indicates '
  + 'evidence status for tracked requirements; it does not guarantee that every relevant datapoint has '
  + 'been captured or verified.',

  'This report is intended to provide preliminary insight and directional guidance. It does not '
  + 'constitute engineering, environmental, legal, financial, or other professional advice. Validate '
  + 'all findings, assumptions, scores, and recommendations through your own due diligence and '
  + 'qualified advisors before making decisions.',

  'Datacrate provides this report "as is," without warranties of any kind, express or implied. '
  + 'To the fullest extent permitted by applicable law, Datacrate and its affiliates disclaim '
  + 'liability for any loss or damages arising from use of or reliance on this report. Interpretation '
  + 'and use of this report are solely your responsibility.',
];

/** Single block for callers that need one string (e.g. email footers). */
export const REPORT_LEGAL_DISCLAIMER_TEXT = REPORT_LEGAL_DISCLAIMER_PARAGRAPHS.join('\n\n');
